import React from "react";
import Box from "@mui/material/Box";
import HotelTabs from "../components/Hotel/Tabs";
import HotelStaffLogsTable from "../components/Hotel/HotelStaffLogs/StaffLogstable";

export default function HotelRoomPage() {
    return (
        <Box sx={{ width: "100%" }}>
            <HotelTabs />
            <HotelStaffLogsTable />
        </Box>
    );
}
